export const APP_URLS = {
  loginPath: 'login',
  homePath: 'home',
  imputationPath: 'imputaciones',
  calendarManagementPath: 'gestion-calendarios',
  calendarLockPath: 'bloqueo-calendarios',
  exportPath: 'exportacion',
  distributorPath: 'distribuidora',
  employeeManagementPath: 'gestion-empleados',
  employeeImputationManagementPath: 'gestion-imputacion-empleado',
  projectManagementPath: 'gestion-proyectos',
  projectRecognitionPath: 'reconocimiento-proyectos',
  customerManagementPath: 'gestion-cliente',
  errorServerPath: 'error/server',
  errorInternalPath: 'error/internal',
};
